<apx-chart [series]="employeeChart.series" [plotOptions]="employeeChart.plotOptions"
[dataLabels]="employeeChart.dataLabels" [chart]="employeeChart.chart" [legend]="employeeChart.legend"
[colors]="employeeChart.colors" [tooltip]="employeeChart.tooltip" [xaxis]="employeeChart.xaxis"
[yaxis]="employeeChart.yaxis" [grid]="employeeChart.grid"></apx-chart>